/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import ModulesContext from "../ModulesContext";
import ChainOfCustodyModule from "components/ChainOfCustody";

function ChainOfCustody({ onCancel }) {
    const dispatch = useDispatch();

    const { currentFileCase, module } = useContext(ModulesContext);

    useEffect(() => {
        if (!currentFileCase) {
            dispatch(notifyError("You have to select a client file first!"));
            onCancel();
        }
    }, [currentFileCase]);

    return (
        <ChainOfCustodyModule
            fileCaseFilter={{
                fileCaseId: currentFileCase.id,
                module: module.dbName,
                fileNo: currentFileCase.fileNo,
                client: currentFileCase.client,
            }}
        />
    );
}

ChainOfCustody.propTypes = {
    onCancel: PropTypes.func,
};

ChainOfCustody.defaultProps = {
    onCancel: () => {},
};

export default withRouter(ChainOfCustody);
